// extracted by mini-css-extract-plugin
export default {"autocomplete":"Autocomplete_autocomplete__Inata","suggestions":"Autocomplete_suggestions__yxyjy","listItem":"Autocomplete_listItem__OZjyL"};